// extracted by mini-css-extract-plugin
export var dropdown = "_uw-0";
export var imageWrapper = "_uw-3";
export var itemNameContainer = "_uw-1";
export var productImage = "_uw-2";
export var spinnerWrapper = "_uw-4";